import {Component, Input, SimpleChanges, ViewChild, Output, EventEmitter, ChangeDetectorRef, OnChanges} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { FilterPagination, RequestInvoices, ResultsInvoice, } from '../../interface/company-client.interface';
import { CdkContextMenuTrigger } from '@angular/cdk/menu';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { OperationModalComponent } from '../../modals/operation-modal/operation-modal.component';
import { DetalleFactVComponent } from '../information/detalle-fact-v/detalle-fact-v.component';

@Component({
  selector: 'app-fact-docs-client',
  templateUrl: './fact-docs-client.component.html',
  styleUrls: ['./fact-docs-client.component.scss'],
})
export class FactDocsClientComponent implements OnChanges {
  @Input() resultsInvoice: ResultsInvoice;
  @Input() requestInvoice: RequestInvoices;
  @Input() sortOrder: string = '';
  @Output() operationBoolean = new EventEmitter();
  @Output() pages: EventEmitter<any> = new EventEmitter();
  @Output() changeSortOrder = new EventEmitter<string>;
  @Output() viewInvoiceBuyOrder: EventEmitter<number> = new EventEmitter();
  @Output() viewRelationWithClient = new EventEmitter<number>;
  @ViewChild(MatSort, { static: true }) sort: MatSort = Object.create(null);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator = Object.create(null);
  public resultsInvoiceFormula: ResultsInvoice;
  public menu!: CdkContextMenuTrigger;
  public dataModal: ResultsInvoice;
  public dataSource!: MatTableDataSource<ResultsInvoice>;

  public displayedColumns: string[] = [
    'folio',
    'clientName',
    'clientRut',
    'totalAmount',
    'fechaDocto',
    'hasBuyOrder',
    'isCedible',
    'numberInvoice',
    'numberInvoiceInFactoring',
    'iconOperation',
  ];

  constructor(private cdref: ChangeDetectorRef, public dialog: MatDialog,) {}

  ngOnInit() {

  }

  //esto es lo que yo le envio
  ngAfterViewInit() {
    this.paginator.page.subscribe((e) => {
      const pages: FilterPagination = {
        pageSize: e.pageSize,
        page: e.pageIndex + 1,
      };
      this.pages.emit(pages);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.resultsInvoice) {
      this.setDataSource(this.resultsInvoice);
    }
    if(this.sortOrder) {
      this.setSortOrder(this.sortOrder);
    }
  }

  setSortOrder(sortOrder: string) {
    if(!sortOrder) {
      this.sort.direction = '';
      this.sort.active = '';
    } else {
      const sorting = sortOrder.split('_');
      const activeCol = sorting[0] ?? '';
      const direction = sorting[1] ?? '';
      this.sort.active = activeCol.charAt(0).toLowerCase() + activeCol.slice(1);
      if(activeCol) {
        this.sort.direction = direction === 'asc' ? 'asc' : 'desc';
      }
    }
    this.dataSource.sort = this.sort;

  }

  setDataSource(dataSource: any) {
    const { results, totalRows, pageSize, currentPage } = dataSource || {};
    this.dataSource = new MatTableDataSource<ResultsInvoice>(results);
    this.dataSource.sort = this.sort;
    this.paginator.pageIndex = currentPage -1;
    this.paginator.length = totalRows;
    this.paginator.pageSize = pageSize;
 }

  setDataSourceRequest(dataSource: RequestInvoices) {
    const { results, currentPage, pageSize, totalRows } = dataSource || {};
    this.dataSource = new MatTableDataSource<ResultsInvoice>(results);
    if (currentPage && pageSize) {
      this.paginator.length = totalRows;
      this.dataSource.sort = pageSize;
    }
  }

  openDialog(invoiceId: number): void {
    this.viewInvoiceBuyOrder.emit(invoiceId);
  }

  openDialogOperation(value: ResultsInvoice): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.width = '60%';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.height = '615px';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.data = value;

    const dialogRef = this.dialog.open(OperationModalComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      this.operationBoolean.emit(result);
    });
  }

  public openDetalleFactura(value: ResultsInvoice) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '60%';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.height = '600px';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.data = value;

    const dialogRef = this.dialog.open(DetalleFactVComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      this.operationBoolean.emit(result);
    });
  }

  sortChange(sortState: Sort) {
    if(sortState.direction === "") {
      this.changeSortOrder.emit(null);
      return;
    }
    const sortCol = sortState.active.charAt(0).toUpperCase() + sortState.active.slice(1);
    const sortConf = `${sortCol}_${sortState.direction}`;
    this.changeSortOrder.emit(sortConf);  
  }

  viewDebtorRelation(fullRut: string) {
    const rut = fullRut.replace(/\./g,'').split('-')[0];
    this.viewRelationWithClient.emit(Number.parseInt(rut));
  }

}
